/* eslint-disable no-console */
/* eslint-disable no-nested-ternary */
/* eslint-disable react/prop-types */
/* eslint-disable react/jsx-one-expression-per-line */

import React from 'react'
import { Form } from 'react-final-form'
import { useSelector } from 'react-redux'

import { H2 } from '@piconetworks/heading'
import ConditionAggregator from '@piconetworks/condition-aggregator'
import StripeDecorator from '@piconetworks/stripe-decorator'
import Loading from '@piconetworks/loading'
import Boutton from '@piconetworks/boutton'
import { OrderSummaryContainer } from '@piconetworks/order-summary'

import Loader from 'common/modules/loader'
import PopupsProcessor from 'common/modules/popupsProcessor'
import Internal from 'common/modules/internal'

import getFields from 'apps/lib/getFields'
import observers from 'apps/lib/observers'
import WizardRedux from 'common/pkgs/WizardRedux'
import orderTypes from 'apps/lib/CartHelper/orderTypes'

import styles from './FinalizePayment.module.scss'

const FinalizePayment = (props) => {
    const {
        CardElement,
        stripe,
        elements,
        linkColor,
        publisherName,
        publisherId,
        paymentMethodsData,
        defaultPaymentMethod,
        dispatch,
        type = '',
        postDataAction,
        OrderSummary,
        WizardSlider,
        onBackButtonClick,
        wizardPayload,
        deleteCard,
    } = props

    const paymentFields = getFields([{
        id: 'payment',
        title: 'Payment',
        description: 'payment description',
        type: 'Payment',
        required: true,
        order: 15,
        deleteCard,
    }])

    const isGift = type.includes('gift')
    const isExisting = type.includes('existing')
    const isSwitch = type.includes('switch')
    const { option, product, customPrice } = OrderSummary().props

    const {
        optionPrice,
        optionInterval,
        trialPrice,
        isTrial,
        isFree,
        trialFinishDate,
    } = useSelector((state) => Loader.selectors.orderSummary(
        state,
        {
            optionId: option?.id,
            productId: product?.id,
            customPrice,
        },
    )) || {}

    const buttonText = (isFree && !isGift)
        ? 'Start free trial'
        : (isTrial && !isGift)
            ? `Pay ${trialPrice}`
            : isSwitch
                ? 'Switch'
                : isGift && isExisting
                    ? 'Keep Gift'
                    : isGift
                        ? 'Give Gift'
                        : 'Pay'

    const renderLoading = <Loading className={styles.btnLoading} />

    const disclaimer = {
        isGift: `You will be charged ${optionPrice} one time covering the first ${optionInterval} of your gift.`,
        isTrial: `You will be charged ${trialPrice} today and ${optionPrice} on ${trialFinishDate}`,
        isFree: `You will not be charged until ${trialFinishDate}.`,
    }

    return (
        <WizardSlider
            title={`Complete your ${isExisting ? 'order' : 'payment'}.`}
            description=""
            linkColor={linkColor}
            onBackButtonClick={onBackButtonClick}
        >
            <WizardRedux.Step
                onSubmit={() => ({})}
                render={({
                    form,
                }) => (
                    <ConditionAggregator
                        Submit={({ disabled, isSubmitting }) => (
                            <div>
                                {(isTrial || isGift) && (
                                    <p className={styles.disclaimer}>
                                        {isGift
                                            ? disclaimer.isGift
                                            : isFree
                                                ? disclaimer.isFree
                                                : disclaimer.isTrial}
                                        {' '}Your payment will be subject to Pico’s <u>terms</u>.
                                    </p>
                                )}
                                <Boutton
                                    block
                                    type="submit"
                                    className={styles.btnSubmit}
                                    disabled={disabled}
                                    style={{
                                        backgroundColor: linkColor,
                                        color: '#fff',
                                    }}
                                >
                                    {isSubmitting ? renderLoading : buttonText}
                                </Boutton>
                            </div>
                        )}
                        onSubmit={async (e, data) => {
                            // clear popups queue
                            dispatch(Internal.creators.sendMessage({
                                payload: {
                                    target: 'pico_arbiter',
                                    ...PopupsProcessor.creators.clear(),
                                },
                            }))

                            // paynow???
                            console.log('onSubmit', data)

                            const { state } = data

                            const {
                                isComplete, required, ...planPayload
                            } = state.plan

                            const preSubmitErrors = Object.values(data.preSubmitHookResults).find(
                                (preSubmitHookResult) => {
                                    const { error } = preSubmitHookResult || {}
                                    return !!error
                                },
                            )

                            if (preSubmitErrors?.error) {
                                throw new Error(preSubmitErrors.error)
                            }
                            if (
                                type.includes(orderTypes.gift.new.regular.type)
                                || type.includes(orderTypes.gift.new.pledge.type)
                            ) {
                                const { action, payload } = postDataAction()

                                await observers.createGift({
                                    dispatch,
                                    payload: {
                                        ...wizardPayload,
                                        ...planPayload,
                                        ...payload,
                                    },
                                    action,
                                })
                            } else if (type.includes(orderTypes.gift.existing.convert.type)) {
                                const { action, payload } = postDataAction()

                                await observers.convertGift({
                                    dispatch,
                                    payload: {
                                        ...wizardPayload,
                                        ...planPayload,
                                        ...payload,
                                    },
                                    action,
                                })
                            } else if (type.includes(orderTypes.donation.new.oneTime.type)) {
                                const { action, payload } = postDataAction()

                                await observers.confirmOneTimeDonation({
                                    dispatch,
                                    payload: {
                                        ...wizardPayload,
                                        ...planPayload,
                                        ...payload,
                                    },
                                    action,
                                })
                            } else {
                                const { action, payload } = postDataAction()

                                await observers.confirmPayment({
                                    dispatch,
                                    payload: {
                                        ...wizardPayload,
                                        ...planPayload,
                                        ...payload,
                                        isSwitch,
                                    },
                                    action,
                                })
                            }
                        }}
                        conditions={{
                            plan: {
                                required: true,
                                isComplete: true,
                                Component: () => (
                                    <section className={styles.orderSummary}>
                                        <H2>Order Summary</H2>
                                        <OrderSummaryContainer>
                                            <OrderSummary />
                                        </OrderSummaryContainer>
                                    </section>
                                ),
                            },
                            // discountCode: {
                            //     required: false,
                            //     isComplete: false,
                            //     Component: ({ changeCompletionStatus, isComplete }) => (
                            //         <section className={styles.discountCode}>
                            //             <H3>Discount Code</H3>
                            //             <p>
                            //                 Can submit? (
                            //                 <input
                            //                     checked={isComplete}
                            //                     type="checkbox"
                            //                     onChange={({
                            //                         target: {
                            //                             checked
                            //                         }
                            //                     }) => changeCompletionStatus({
                            //                         isComplete: checked,
                            //                     })}
                            //                 />
                            //                 )
                            //             </p>
                            //         </section>
                            //     ),
                            // },
                            payment: {
                                required: true,
                                isComplete: false,
                                Component: (ownProps) => (
                                    <Form
                                        onSubmit={() => { }}
                                        render={() => (
                                            <>
                                                {paymentFields.map((Field) => (
                                                    <Field
                                                        {...ownProps}
                                                        existingPaymentMethods={paymentMethodsData}
                                                        defaultPaymentMethod={defaultPaymentMethod}
                                                        linkColor={linkColor}
                                                        publisherName={publisherName}
                                                        CardElement={CardElement}
                                                    />
                                                ))}
                                            </>
                                        )}
                                    />
                                ),
                                preSubmit: async (data) => {
                                    const {
                                        state: {
                                            payment: {
                                                selectedPaymentMethod,
                                                account_id: accountId,
                                                public_token: publicToken,
                                                isComplete,
                                            } = {},
                                        } = {},
                                    } = data

                                    if (!isComplete) {
                                        return false
                                    }

                                    let stripeData

                                    switch (selectedPaymentMethod) {
                                        case 'add_bank_account':
                                            if (!accountId) {
                                                throw new Error('unable to determine bank account id')
                                            }

                                            if (!publicToken) {
                                                throw new Error('unable to determine bank public token')
                                            }

                                            // before payment completes, we get a copy of the loader
                                            // that won't include the purchase being bought
                                            // resulting in a popup queue
                                            // flag off through executePopupsProcessor
                                            await observers.addPaymentMethod({
                                                dispatch,
                                                payload: {
                                                    token: {
                                                        accountId,
                                                        id: publicToken,
                                                        type: 'bank',
                                                    },
                                                    publisherId,
                                                    executePopupsProcessor: false,
                                                },
                                            })

                                            break

                                        case 'add_card':
                                            stripeData = await stripe.createToken(
                                                elements.getElement(CardElement),
                                            )

                                            await observers.addPaymentMethod({
                                                dispatch,
                                                payload: {
                                                    token: stripeData.token,
                                                    publisherId,
                                                    executePopupsProcessor: false,
                                                },
                                            })

                                            break

                                        default:
                                            await observers.setDefaultPaymentMethod({
                                                dispatch,
                                                payload: {
                                                    sourceId: selectedPaymentMethod,
                                                    publisherId,
                                                    executePopupsProcessor: false,
                                                },
                                            })

                                            break
                                    }

                                    return null
                                },
                            },
                        }}
                        postSubmit={(data) => {
                            // check postSubmit for errors
                            // inform the wizard we're done
                            console.log('postSubmit', data)
                            form.submit()
                            // throw new Error('oops')
                        }}
                    />
                )}
            />
        </WizardSlider>
    )
}

export default (props) => (
    <StripeDecorator
        stripePublicKey={process.env.REACT_APP_STRIPE_PUBLIC_KEY}
    >
        <FinalizePayment {...props} />
    </StripeDecorator>
)
